import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: ()=>import("../views/HomeView.vue"),
    meta: {
      title: '签到'
    }
  },
  {
    path: '/DiscountCoupons',
    name: 'DiscountCoupons',
    component: ()=>import("../views/DiscountCoupons.vue"),
    meta: {
      title: '优惠卡券'
    }
  },
  {
    path: '/PhoneBill',
    name: 'PhoneBill',
    component: ()=>import("../views/PhoneBill.vue"),
    meta: {
      title: '话费充值'
    }
  },
  {
    path: '/DrawRaffle',
    name: 'DrawRaffle',
    component: ()=>import("../views/DrawRaffle.vue"),
    meta: {
      title: '话费充值'
    }
  },
  {
    path: '/integralGame',
    name: 'integralGame',
    component: ()=>import("../views/integralGame.vue"),
    meta: {
      title: '积分游戏'
    }
  },
  {
    path: '/leisureGame',
    name: 'leisureGame',
    component: ()=>import("../views/leisureGame.vue"),
    meta: {
      title: '休闲游戏'
    }
  },
  {
    path: '/PointsTreasures',
    name: 'PointsTreasures',
    component: ()=>import("../views/PointsTreasures.vue"),
    meta: {
      title: '积分夺宝'
    }
  },
  {
    path: '/PointsMall',
    name: 'PointsMall',
    component: ()=>import("../views/PointsMall.vue"),
    meta: {
      title: '积分夺宝'
    }
  },
  {
    path: '/myCenter',
    name: 'myCenter',
    component: ()=>import("../views/myCenter.vue"),
    meta: {
      title: '我的'
    }
  },
  {
    path: '/ProductDetails',
    name: 'ProductDetails',
    component: ()=>import("../views/ProductDetails.vue"),
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/confirmanOrder',
    name: 'confirmanOrder',
    component: ()=>import("../views/confirmanOrder.vue"),
    meta: {
      title: '确认订单'
    }
  },
  {
    path: '/wxChat',
    name: 'wxChat',
    component: ()=>import("../views/wxChat.vue"),
    meta: {
      title: '支付'
    }
  },
  {
    path: '/PointsDetail',
    name: 'PointsDetail',
    component: ()=>import("../views/PointsDetail.vue"),
    meta: {
      title: '积分明细'
    }
  },
  {
    path: '/myIndent',
    name: 'myIndent',
    component: ()=>import("../views/myIndent.vue"),
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/myAddress',
    name: 'myAddress',
    component: ()=>import("../views/myAddress.vue"),
    meta: {
      title: '收货地址'
    }
  },
  {
    path: '/putAddress',
    name: 'putAddress',
    component: ()=>import("../views/putAddress.vue"),
    meta: {
      title: '修改地址'
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=>{
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})
export default router
